import styled from "styled-components";

export const Container = styled.div`
  height: auto;
  width: 100vw;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Fira Sans", sans-serif;
  transform-style: preserve-3d;
  margin: 0 0 5rem 0;
`;

export const Wrap = styled.div`
  margin: 5em 0;
  text-align: center;
  width: 80vw;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 4rem;
`;

export const Paragraph = styled.p`
  color: #181818;
  font-size: 1.8rem;

  span {
    font-weight: bold;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 1;
  flex-wrap: wrap;
  width: 90vw;

  
`;

export const Card = styled.div`
  width: 25vw;
  height: 25vw;
  margin: 40px;
  background: #181818;
  border-radius: 20px;
  transform-style: preserve-3d;
  position: relative;

  @media (min-width: 901px) and (max-width: 1500px) {
    width: 40vw;
  height: 40vw;
  }

  @media (max-width: 900px) {
    width: 70vw;
  height: 70vw;
  }

  &:before {
    content: "Header";
    position: absolute;
    top: 20px;
    left: 20px;
    font-size: 1rem;
    font-weight: 500;
    color: white;
    font-style: "Fira Sans", sans-serif;
  }

  div {
    position: absolute;
    top: 50%;
    z-index: 10;
    left: 50%;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: white;
    transition: 0.5s;
    opacity: 0.5;
    transform-style: preserve-3d;
    transform: translate3d(-50%, -50%, 50px);
  }

  &:hover {
    .productName {
      top: 40px;
      opacity: 1;
    }
    .productButton {
      bottom: 30px;
      opacity: 1;
    }

    div {
      opacity: 1;
    }
  }
`;

export const ProductName = styled.h2`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  text-align: center;
  color: white;
  width: 100%;
  transition: 0.5s;
  z-index: 10;
  transform-style: preserve-3d;
  transform: translate3d(0, 0, 75px);
`;

export const AddButton = styled.button`
  position: absolute;
  bottom: 0;
  left: 30%;
  transform-style: preserve-3d;
  transform: translate3d(-50%, 0, 75px);
  color: white;
  background: #22d976;
  border: 1px solid #22d976;
  border-radius: 5px;
  padding: 15px 35px;
  transition: 0.5s;
  z-index: 10;
  opacity: 0;
  cursor: pointer;

  &:hover {
    background-color: #44e991;
  }
`;

export const InfoButton = styled.button`
  position: absolute;
  bottom: 0;
  right:0;
  transform-style: preserve-3d;
  transform: translate3d(-50%, 0, 75px);
  color: white;
  background: transparent;
  border: 1px solid #22d976;
  border-radius: 5px;
  padding: 15px 35px;
  transition: 0.5s;
  z-index: 10;
  opacity: 0;
  cursor: pointer;

  &:hover {
    background-color: #44e991;
  }
`;

export const ProductImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 300px;
  transition: 0.5s;
  z-index: 11;
  transform-style: preserve-3d;
  transform: translate3d(-50%, -50%, 0px) rotateX("angle");
`;
